import { create } from 'zustand';

interface ToastState {
  message: string | null;
  variant: 'info' | 'error';
  show: (message: string, variant?: 'info' | 'error') => void;
  clear: () => void;
}

let timer: ReturnType<typeof setTimeout> | null = null;

export const useToastStore = create<ToastState>((set) => ({
  message: null,
  variant: 'info',
  show: (message, variant = 'info') => {
    if (timer) clearTimeout(timer);
    set({ message, variant });
    timer = setTimeout(() => set({ message: null }), 3000);
  },
  clear: () => set({ message: null }),
}));
